import { LinearProgress } from "@material-ui/core";

export const LoginLoading = () => {
  return (
    <div
      className="container-fluid"
      style={{ position: "fixed", zIndex: "100000" }}
    >
      <LinearProgress color="primary" />
      <LinearProgress color="primary" />
    </div>
  );
};
